import { ReactNode } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';

const MODE_TRANSITION = {
    INITIAL_Y_OFFSET: -10,
    DURATION: 0.1,
} as const;

interface AnimatedActionBarModeTransitionProps {
    isMultiSelectMode: boolean;
    browseSlot: ReactNode;
    selectionSlot: ReactNode;
}

export function AnimatedActionBarModeTransition({
    isMultiSelectMode,
    browseSlot,
    selectionSlot,
}: AnimatedActionBarModeTransitionProps) {
    const prefersReducedMotion = useReducedMotion();
    const motionYOffset = prefersReducedMotion
        ? 0
        : MODE_TRANSITION.INITIAL_Y_OFFSET;
    const motionDuration = prefersReducedMotion ? 0 : MODE_TRANSITION.DURATION;
    const motionOpacityInactive = prefersReducedMotion ? 1 : 0;

    const motionProps = {
        initial: { opacity: motionOpacityInactive, y: motionYOffset },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: motionOpacityInactive, y: motionYOffset },
        transition: { duration: motionDuration },
    };

    return (
        <AnimatePresence mode="wait">
            {!isMultiSelectMode ? (
                <motion.div key="browse" {...motionProps}>
                    {browseSlot}
                </motion.div>
            ) : (
                <motion.div key="selection" {...motionProps}>
                    {selectionSlot}
                </motion.div>
            )}
        </AnimatePresence>
    );
}
